import { MicrosoftTeamsLinkedService } from 'shell-models-lib';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Model } from '../../backendmodel';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MicrosoftTeamsLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class MicrosoftTeamsLinkedServiceAdapter extends LinkedServiceAdapter<MicrosoftTeamsLinkedService> {

    protected modelConstructor(): new () => MicrosoftTeamsLinkedService {
        return MicrosoftTeamsLinkedService;
    }

    protected model(): IModel {
        return MicrosoftTeamsLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(_linkedService: MicrosoftTeamsLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }
    
    protected async propertiesToModelAsync(_linkedServiceResource: Model.LinkedServiceResource, linkedService: MicrosoftTeamsLinkedService): Promise<MicrosoftTeamsLinkedService> {
        return linkedService;
    }
}
